<template>
  <div id="app">
    <game-base/>
  </div>
</template>

<script>
import GameBase from '@/modules/simon-game/game-base.vue'

export default {
  name: 'App',
  components: {
    GameBase
  },
  methods: {
    changeView (view) {
      this.currentView = this.views[view]
    }
  }
}
</script>

<style lang="scss">
html,
body {
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue